import { defineComponent, h } from 'vue'
import { QBtnDropdown, QIcon } from 'quasar'

import { bsBtnProps, useBsBtn } from './BsBtn'
import { quasarHandlers } from '../quasarHandlers'

/**
 * A button with a menu. Renders QBtnDropdown but keeps BsBtn's classes so it looks identical, which is
 * why it spreads BsBtn's props and helpers rather than extending it.
 *
 * `inheritAttrs: false` because the attributes are placed by hand below.
 */
export default defineComponent({
  name: 'BsBtnDropdown',

  inheritAttrs: false,

  props: bsBtnProps,

  setup (props, { emit }) {
    return { ...useBsBtn(props, emit) }
  },

  methods: {
    /** BsBtn's own, repeated rather than inherited — see the class note above. */
    renderActiveIcon () {
      if (this.active === false) return void 0

      return h(QIcon, {
        class: 'bs-btn-active__icon',
        name: 'icon-check'
      })
    },

    getProps (): Record<string, unknown> {
      return {
        dropdownIcon: 'app:arrow-down'
      }
    }
  },

  render () {
    return h(QBtnDropdown, {
      // The second entry is what makes it use BsBtn's styles.
      class: ['bs-btn bs-btn-dropdown', this.getBtnClasses()],
      ...this.getBtnProps(),
      ...this.getProps(),
      ...quasarHandlers(this.getListeners()),
      ...this.getAttributes({ ...this.$attrs })
    // QBtnDropdown is a component: its panel content has to be a slot function, not an array.
    }, {
      default: () => [
        this.renderActiveIcon(),
        this.slot(this, 'default')
      ]
    })
  }
})
